import { useQuery } from "@tanstack/react-query";
import { PagesAPI } from "api";

const fetchData = () => {
  return PagesAPI.get();
};
export const useFetchPages = () => {
  return useQuery({
    queryKey: ["pages"],
    queryFn: fetchData,
  });
};
